import portalAi from '@/page/h5/portalAi'
import portalLm from '@/page/h5/portalLm'
import portalEdu from '@/page/h5/portalEdu'
import portalLMAES from '@/page/h5/portalLMAES'
const routes = [
    {
		path: '/h5/portal/ai',
		name: 'h5-portal-ai',
		component: portalAi
	},
	{
		path: '/h5/portal/lm',
		name: 'h5-portal-lm',
		component: portalLm
	},
	{
		path: '/h5/portal/edu',
		name: 'h5-portal-edu',
		component: portalEdu
	},
	{
		path: '/h5/portal/lmaes',
		name: 'h5-portal-lmaes',
		component: portalLMAES
	}
]

export default routes;



// WEBPACK FOOTER //
// ./src/router/h5.js